import React, { memo } from 'react';
import VideoModal from '../../../pop-ups/video-modal';
// gatsby
import Img, { FluidObject } from 'gatsby-image';
import { Link } from 'gatsby';
//hooks
import useModal from '../../../../hooks/useModal';
//styles
import styles from './project-card.module.css';
//icons
import PlayBtn from '../../../../images/career/pink-btn.inline.svg';

interface IProjectCardProps {
  cardTitle?: string;
  rating?: {
    number: string;
    stars: { icon: React.ReactNode; id: string }[];
  };
  description?: string;
  industry?: string;
  location?: string;
  technology?: string[];
  team?: string;
  image: FluidObject | FluidObject[];
  source: string;
  posterImg?: any;
  route?: string;
}

function ProjectCard({
  cardTitle,
  rating,
  description,
  industry,
  location,
  technology,
  team,
  image,
  source,
  route,
}: IProjectCardProps) {
  const { handleModal } = useModal();

  return (
    <li className={styles.card} key={cardTitle}>
      <div
        className={styles.thumb}
        onClick={() =>
          handleModal(
            <VideoModal
              source={`${process.env.GATSBY_STRAPI_CDN}/video/${source}`}
              preload="auto"
              autoPlay={true}
              controls
              width="100%"
              height="auto"
            />,
            false
          )
        }
      >
        <Img fluid={image} className={styles.img} alt="poster of video" />
        <PlayBtn className={styles.playBtn} />
      </div>
      <div className={styles.item}>
        <h2 className={styles.cardTitle}>{cardTitle}</h2>
        <p className={styles.description}>{description}</p>
        <table className={styles.table}>
          <tbody>
            <tr>
              <td className={styles.fieldName}>Industry</td>
              <td className={styles.fieldValue}>{industry}</td>
            </tr>
            <tr>
              <td className={styles.fieldName}>Location</td>
              <td className={styles.fieldValue}>{location}</td>
            </tr>
            <tr>
              <td className={styles.fieldName}>Technology</td>
              <td className={styles.fieldValue}>
                <ul className={styles.techList}>
                  {technology &&
                    technology.map((technology, i) => (
                      <li key={i} className={styles.techItem}>
                        <img
                          src={technology}
                          className={styles.techLogo}
                          alt={`${technology} logo`}
                        />
                      </li>
                    ))}
                </ul>
              </td>
            </tr>
            <tr>
              <td className={styles.fieldName}>Team</td>
              <td className={styles.fieldValue}>{team}</td>
            </tr>
          </tbody>
        </table>
        {route && (
          <Link className={styles.learnMore} to={route}>
            Learn more
          </Link>
        )}
      </div>
    </li>
  );
}

export default memo(ProjectCard);
